import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { SearchIcon, ShoppingCartIcon, UserIcon, HeartIcon, MenuIcon, XIcon, PhoneIcon } from 'lucide-react';
import { useCart } from '../../context/CartContext';
import { useAuth } from '../../context/AuthContext';
import { Input } from '../ui/Input';
import { formatPrice } from '../../utils/formatters';
export function Header() {
  const {
    itemCount,
    total
  } = useCart();
  const {
    isAuthenticated,
    user
  } = useAuth();
  const [searchQuery, setSearchQuery] = useState('');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  return <header className="sticky top-0 z-40 bg-white shadow-sm" data-id="element-365">
      {/* Top bar */}
      <div className="bg-gray-900 text-white text-sm py-2" data-id="element-366">
        <div className="max-w-7xl mx-auto px-4 flex items-center justify-between" data-id="element-367">
          <div className="flex items-center gap-4" data-id="element-368">
            <span className="flex items-center gap-1" data-id="element-369">
              <PhoneIcon className="w-3.5 h-3.5" data-id="element-370" />
              +92-313-2370605
            </span>
            <span className="hidden sm:inline" data-id="element-371">|</span>
            <span className="hidden sm:inline" data-id="element-372">
              Free shipping on orders over PKR 5,000
            </span>
          </div>
          <div className="flex items-center gap-4" data-id="element-373">
            <Link to="/contact" className="hover:text-primary-300 transition-colors" data-id="element-374">
              Help
            </Link>
            <Link to="/track-order" className="hover:text-primary-300 transition-colors" data-id="element-375">
              Track Order
            </Link>
          </div>
        </div>
      </div>

      {/* Main header */}
      <div className="max-w-7xl mx-auto px-4 py-4" data-id="element-376">
        <div className="flex items-center justify-between gap-4" data-id="element-377">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0" data-id="element-378">
            <div className="flex items-center gap-2" data-id="element-379">
              <img src="https://cdn.magicpatterns.com/uploads/fRsBpVfPoCHsQawYgHjccg/ChatGPT_Image_Mar_6,_2026,_03_48_02_AM.png" alt="Gadgets Zone" className="h-10 w-auto object-contain" data-id="element-380" />
              <div className="hidden sm:block" data-id="element-381">
                <h1 className="text-xl font-bold text-gray-900" data-id="element-382">
                  Gadgets Zone
                </h1>
                <p className="text-xs text-gray-500" data-id="element-383">
                  Affordable gadgets for everyday life
                </p>
              </div>
            </div>
          </Link>

          {/* Search bar */}
          <div className="flex-1 max-w-2xl hidden md:block" data-id="element-384">
            <div className="relative" data-id="element-385">
              <Input type="search" placeholder="Search for products, brands and more..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} leftIcon={<SearchIcon className="w-5 h-5" data-id="element-387" />} className="pr-24" data-id="element-386" />
              <button className="absolute right-2 top-1/2 -translate-y-1/2 bg-primary-600 text-white px-4 py-1.5 rounded-md text-sm font-medium hover:bg-primary-700 transition-colors" data-id="element-388">
                Search
              </button>
            </div>
          </div>

          {/* Actions */}
          <div className="flex items-center gap-2 sm:gap-4" data-id="element-389">
            {isAuthenticated ? <Link to="/account" className="hidden sm:flex items-center gap-2 text-gray-700 hover:text-primary-600 transition-colors" data-id="element-390">
                <UserIcon className="w-5 h-5" data-id="element-391" />
                <span className="text-sm font-medium" data-id="element-392">
                  {user?.name?.split(' ')[0]}
                </span>
              </Link> : <Link to="/login" className="hidden sm:flex items-center gap-2 text-gray-700 hover:text-primary-600 transition-colors" data-id="element-393">
                <UserIcon className="w-5 h-5" data-id="element-394" />
                <span className="text-sm font-medium" data-id="element-395">Login / Register</span>
              </Link>}

            <Link to="/wishlist" className="hidden sm:flex p-2 text-gray-700 hover:text-primary-600 transition-colors relative" aria-label="Wishlist" data-id="element-396">
              <HeartIcon className="w-5 h-5" data-id="element-397" />
            </Link>

            <Link to="/cart" className="flex items-center gap-2 bg-primary-600 text-white px-3 py-2 rounded-lg hover:bg-primary-700 transition-colors" aria-label={`Shopping cart with ${itemCount} items`} data-id="element-398">
              <ShoppingCartIcon className="w-5 h-5" data-id="element-399" />
              <span className="font-medium" data-id="element-400">{formatPrice(total)}</span>
              {itemCount > 0 && <span className="bg-white text-primary-600 text-xs font-bold w-5 h-5 rounded-full flex items-center justify-center" data-id="element-401">
                  {itemCount}
                </span>}
            </Link>

            {/* Mobile menu button */}
            <button className="md:hidden p-2 text-gray-700" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-402">
              {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-403" /> : <MenuIcon className="w-6 h-6" data-id="element-404" />}
            </button>
          </div>
        </div>

        {/* Mobile search */}
        <div className="mt-4 md:hidden" data-id="element-405">
          <Input type="search" placeholder="Search products..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} leftIcon={<SearchIcon className="w-5 h-5" data-id="element-407" />} data-id="element-406" />
        </div>
      </div>

      {/* Mobile menu */}
      {isMobileMenuOpen && <div className="md:hidden bg-white border-t border-gray-100 py-4" data-id="element-408">
          <nav className="max-w-7xl mx-auto px-4 space-y-2" data-id="element-409">
            <Link to="/login" className="flex items-center gap-3 px-4 py-3 text-gray-700 hover:bg-gray-50 rounded-lg" onClick={() => setIsMobileMenuOpen(false)} data-id="element-410">
              <UserIcon className="w-5 h-5" data-id="element-411" />
              Login / Register
            </Link>
            <Link to="/wishlist" className="flex items-center gap-3 px-4 py-3 text-gray-700 hover:bg-gray-50 rounded-lg" onClick={() => setIsMobileMenuOpen(false)} data-id="element-412">
              <HeartIcon className="w-5 h-5" data-id="element-413" />
              Wishlist
            </Link>
          </nav>
        </div>}
    </header>;
}